"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _Storyblok = _interopRequireDefault(require("../../../../../../utils/Storyblok"));

var _customProps = require("../../../../../../utils/customProps");

var _MuiTypography = _interopRequireDefault(require("../../../../../MuiTypography/MuiTypography"));

/* eslint-disable max-len */
var MuiTableCell = function MuiTableCell(_ref) {
  var content = _ref.content,
      rootClass = _ref.rootClass,
      align = _ref.align,
      padding = _ref.padding,
      size = _ref.size,
      sortDirection = _ref.sortDirection;

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass);

  return /*#__PURE__*/_react.default.createElement(_core.TableCell, {
    className: styles.root,
    align: align,
    padding: padding,
    size: size,
    sortDirection: sortDirection
  }, /*#__PURE__*/_react.default.createElement(_MuiTypography.default, content[0]));
};

var _default = MuiTableCell;
exports.default = _default;
MuiTableCell.propTypes = {
  /**
   * storyblok multiselect of css classes
   * Mui Override or extend the styles applied to the component.
   */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * mui prop: 'center', 'inherit', 'justify', 'left', 'right'
   * Set the text-align on the table cell content
   */
  align: function align(props, propName, componentName) {
    var validProps = ['center', 'inherit', 'justify', 'left', 'right'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /**
   * mui prop: 'checkbox', 'default', 'none'
   * Sets the padding applied to the cell.
   */
  padding: function padding(props, propName, componentName) {
    var validProps = ['checkbox', 'default', 'none'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /**
   * mui prop: 'small', 'medium'
   * Specify the size of the cell
   */
  size: function size(props, propName, componentName) {
    var validProps = ['small', 'medium'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /**
   * mui prop: 'asc', 'desc', false
   * Set aria-sort direction.
   */
  sortDirection: function sortDirection(props, propName, componentName) {
    var validProps = ['asc', 'desc', 'false'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /**
   * Content passed to render
   * components: MuiTypography,
   */
  content: function content(props, propName, componentName) {
    return (0, _customProps.validComponentsRequired)(props, propName, componentName, ['MuiTypography'], 1);
  }
};
MuiTableCell.defaultProps = {
  align: 'inherit',
  padding: 'default',
  size: 'medium',
  sortDirection: false,
  rootClass: [],
  content: []
};